module.exports = __webpack_public_path__ + "static/media/card-view-3.5737859c.svg";